import React from 'react';
import { Trash2Icon, CheckCircle2Icon } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { formatFriendlyDeadline, isOverdue } from '../../utils/date';
import type { BorrowedItem } from '../../types/borrowedItem';
interface BorrowedItemCardProps {
  item: BorrowedItem;
  onMarkReturned: () => void;
  onDelete?: () => void;
  compact?: boolean;
}
export function BorrowedItemCard({
  item,
  onMarkReturned,
  onDelete,
  compact = false
}: BorrowedItemCardProps) {
  const overdue = !item.returned && !!item.returnDeadline && isOverdue(item.returnDeadline);
  return <div className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm" data-id="element-30" data-mp="21o4sbql0hqmi">
      <div className="flex items-start justify-between gap-3" data-id="element-31" data-mp="1xn2pkzrvywfs">
        <div className="min-w-0" data-id="element-32" data-mp="1xmjbju5cws71">
          <p className="truncate text-sm font-medium text-slate-900" data-id="element-33" data-mp="q9iw9752yu1m">{item.itemName}</p>
          <p className="mt-0.5 text-xs text-slate-500" data-id="element-34" data-mp="q764y3dfn7bw">Lent to {item.borrowedTo}</p>
          <div className="mt-2 flex flex-wrap items-center gap-2" data-id="element-35" data-mp="m6m9r5cf6dse">
            <span className="text-[11px] text-slate-400" data-id="element-36" data-mp="iei9fm2l31nq">Since {format(parseISO(item.dateBorrowed), 'MMM d')}</span>
            {item.returnDeadline && !item.returned && <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${overdue ? 'bg-red-50 text-red-600' : 'bg-amber-50 text-amber-700'}`} data-id="element-37" data-mp="9dbs5as41mtf">
                {overdue ? 'Overdue' : `Due ${formatFriendlyDeadline(item.returnDeadline)}`}
              </span>}
            {item.returned && <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-600" data-id="element-38" data-mp="3luyvatzsy1rn">
                <CheckCircle2Icon className="h-3 w-3" data-id="element-39" data-mp="3qtjvwuiyungm" /> Returned
              </span>}
          </div>
        </div>
        {!compact && onDelete && <button type="button" onClick={onDelete} aria-label={`Delete ${item.itemName}`} className="text-slate-300 transition-colors duration-150 hover:text-red-500" data-id="element-40" data-mp="3hrkei141hhd5">
            <Trash2Icon className="h-4 w-4" data-id="element-41" data-mp="1ik3wilnmc343" />
          </button>}
      </div>
      {!item.returned && <button type="button" onClick={onMarkReturned} className="mt-3 w-full rounded-xl bg-amber-50 py-2 text-xs font-semibold text-amber-700 transition-colors duration-150 hover:bg-amber-100" data-id="element-42" data-mp="1dkhmel3372zi">
          Mark as returned
        </button>}
    </div>;
}